export const inIframe = () => {
  if (typeof window !== 'undefined') {
    return window.self !== window.top;
  } else {
    return false;
  }
};
